import { generalCountConfig, StatTableConfig } from "./configConstructor";

export default new StatTableConfig({
  type: "webhook",
  counts: {
    sent: {
      label: 'Отправлено',
      ...generalCountConfig
    },
    errors: {
      label: 'Ошибки',
      ...generalCountConfig
    }
  },
  charts: {
    errors: { color: 'red' },
  }
});
